import { render, staticRenderFns } from "./cmpgerarparceslasgrupo.vue?vue&type=template&id=11786c90&"
import script from "./cmpgerarparceslasgrupo.vue?vue&type=script&lang=js&"
export * from "./cmpgerarparceslasgrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports